import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'

createApp(App).use(createPinia()).use(router).mount('#app')
// ==================================================== swipe menu for mobile view starts
let touchstartX = 0;
let touchendX = 0;
const nbmob = document.getElementById('navbar-menu');
const nbmobbg = document.getElementById('navbar-menu-bg');
function handleGesture() {
    if(touchendX > touchstartX){
        document.getElementById('navbar-menu').style.left = '110%';
        document.getElementById('navbar-menu-bg').style.width = '0';
    }
}
nbmob.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX
});
nbmob.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX
    handleGesture();
});
nbmobbg.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX
});
nbmobbg.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX
    handleGesture();
});
// ==================================================== swipe menu for mobile view ends
// ==================================================== when window scrolled starts
window.onscroll = function(){
    const chatbox = document.getElementById('chatbox');
    const gotop = document.getElementsByClassName('go-top'); // <================== scroll top icon
    var i;
    if(document.body.scrollTop > 100 || document.documentElement.scrollTop > 100){
        chatbox.classList.add('chatbox-scrolled');
        for(i = 0; i < gotop.length; i++){
            if(screen.width > 1500){
                gotop[i].style.bottom = '5%';
            }else if(screen.width > 750){
                gotop[i].style.bottom = '5%';
            }else{
                gotop[i].style.bottom = '5%';
            }
        }
    }else{
        chatbox.classList.remove('chatbox-scrolled');
        for(i = 0; i < gotop.length; i++){
            gotop[i].style.bottom = '-15%';
        }
    }
    const st = document.getElementsByClassName('sticky-top-board');
    if(st[0]){
        const stpsh = st[0].parentElement.offsetHeight - (st[0].offsetHeight - (66 - 16));
        if(document.body.scrollTop > 66 || document.documentElement.scrollTop > 66){
            if(document.body.scrollTop > stpsh || document.documentElement.scrollTop > stpsh){
                for(i = 0; i < st.length; i++){
                    st[i].classList.remove('stb-active');
                    st[i].classList.add('stb-absolute');
                }
            }else{
                for(i = 0; i < st.length; i++){
                    st[i].classList.remove('stb-absolute');
                    st[i].classList.add('stb-active');
                }
            }
        }else{
            for(i = 0; i < st.length; i++){
                st[i].classList.remove('stb-absolute');
                st[i].classList.remove('stb-active');
            }
        }
    }
    const ob = document.getElementById('sr-order-body');
    if(ob){
        if(screen.width < 1051){
            if(document.body.scrollTop > ((document.body.scrollHeight - screen.height) - 1) || document.documentElement.scrollTop > ((document.body.scrollHeight - screen.height) - 1)){
                if(ob.offsetHeight > 0){
                    ob.style.maxHeight = 0;
                    ob.previousElementSibling.children[0].innerHTML = 'Tampilkan';
                    ob.classList.add('hide-by-scroll');
                }
            }else{
                if(ob.classList.contains('hide-by-scroll')){
                    ob.style.maxHeight = '500px';
                    ob.previousElementSibling.children[0].innerHTML = 'Sembunyikan';
                    ob.classList.remove('hide-by-scroll');
                }
            }
        }
    }
}
// ==================================================== when window scrolled ends
// ==================================================== when window is clicked starts
window.onclick = function(e){
    if(!e.target.classList.contains('btn-cover')){
        const float = document.getElementsByClassName('float');
        const icon = document.getElementsByClassName('float-icon');
        for(var i = 0; i < float.length; i++){
            float[i].classList.remove('sso-active');
        }
        for(i = 0; i < icon.length; i++){
            icon[i].classList.remove('ssb-icon-active');
        }
    }
}
// ==================================================== when window is clicked ends